import { FC } from "react";
import { TableCell, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { categories, colors, getCategoryColor } from "common";
import { CategoryItem } from "modules/category/types";
import { productPriceList } from "modules/pricelist/types";
import {
  categoryNameToId,
  convertCategFormat,
} from "utils/categoryConverterUtils";

const useStyles = makeStyles(
  {
    tableCellBorder: {
      borderRight: "0.5px solid black",
      borderColor: colors.primary,
    },
  },
  { index: 999 }
);

interface Props {
  index: number;
  data: productPriceList;
  categories: CategoryItem[];
}

export const TableCellCategory: FC<Props> = ({ index, data }) => {
  const classes = useStyles();
  const colorVariant = index % 2 ? "100" : "200";

  const categName = convertCategFormat(data?.category_name ?? "");
  const categoryID = categoryNameToId(categName, categories);
  const backgroundColor = getCategoryColor(categoryID || 0)[colorVariant];

  return (
    <TableCell style={{ backgroundColor }} className={classes.tableCellBorder}>
      <Typography
        fontWeight="900"
        fontSize={16}
        color={colors.black}
        sx={{
          display: "-webkit-box",
          overflow: "hidden",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
        }}
      >
        {data?.category_name ?? ""}
      </Typography>
    </TableCell>
  );
};
